export const capitalizeFirstLetter = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

export const getFullName = (firstName, lastName) =>
  [firstName || '', lastName || ''].filter((_) => _).join(' ');

export const getInitials = (firstName, lastName) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
  return `${firstInitial}${lastInitial}`;
};

export const getReadableFileSizeString = (fileSizeInBytes) => {
  var i = -1;
  var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

export const separateCost = (number = 0, characterSeparator = ',') => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, characterSeparator);
};

export const objectToQueryString = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

export const getDeleteTitle = (str) => {
  return `Delete ${str}`;
};

export const getDeleteContent = (str) => {
  return (
    <>
      Are you sure to delete <b>{str}</b>?
    </>
  );
};

export const getFileExtension = (filename) => {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
};

export const formatNumber = (
  number,
  option = {
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  },
  isCurrency = true
) => {
  if (isNaN(number)) return '';
  if (isCurrency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      ...option,
    }).format(number);
  } else {
    if (option) {
      return new Intl.NumberFormat('en-US', option).format(number);
    } else {
      return new Intl.NumberFormat('en-US').format(number);
    }
  }
};

export const checkHaveDecimal = (number) => {
  return number - Math.floor(number) !== 0;
};

export const getFontSizeForAmount = (
  text,
  maxLength = 7,
  baseFontSize = 32,
  minFontSize = 14
) => {
  if (!text) return baseFontSize;

  const textLength = text.length;
  if (textLength <= maxLength) return baseFontSize;

  // Calculate scale factor based on how much longer the text is
  const scaleFactor = Math.max(
    minFontSize / baseFontSize,
    maxLength / textLength
  );
  return Math.max(minFontSize, Math.floor(baseFontSize * scaleFactor));
};
